export default __webpack_public_path__ + "images/7617647bc03b8d6dfc319dde22a73c89-seattle_mobile.webp";